import { render } from "./HeadBar.vue?vue&type=template&id=9b85986e"
import script from "./HeadBar.vue?vue&type=script&lang=js"
export * from "./HeadBar.vue?vue&type=script&lang=js"

import "./HeadBar.vue?vue&type=style&index=0&id=9b85986e&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__